import { render, staticRenderFns } from "./CodexCode.vue?vue&type=template&id=6074743e&scoped=true&"
import script from "./CodexCode.vue?vue&type=script&lang=js&"
export * from "./CodexCode.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=6074743e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6074743e",
  null
  
)

export default component.exports